/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";

// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled, Theme } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }: { theme?: Theme; ownerState: any }) => {
  const { palette, boxShadows, functions, transitions } = theme;
  const { open, darkMode } = ownerState;
  const { transparent, gradients, white, background, grey, black } = palette;
  let borderColor = black.main;
  if(!darkMode){
    borderColor = grey['250'];
  }

  const usernavWidth = 300;
  const { lg } = boxShadows;
  const { pxToRem } = functions;

  // drawer styles when open={true}
  const drawerOpenStyles = () => ({
    width: usernavWidth,
    left: "initial",
    right: 0,
    transition: transitions.create("right", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.short,
    }),
  });

  // drawer styles when open={false}
  const drawerCloseStyles = () => ({
    left: "initial",
    right: pxToRem(-350),
    transition: transitions.create("all", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.short,
    }),
  });

  return {
    "& .MuiDrawer-paper": {
      height: "100vh",
      margin: 0,
      padding: '0px',
      borderRadius: 0,
      boxShadow: lg,
      overflowY: "auto",
      zIndex: 1305,
      borderLeft: "1px solid "+borderColor,
      ...(open ? drawerOpenStyles() : drawerCloseStyles()),
      "& hr": {
        borderColor: borderColor+" !important"
      }
    },
  };
});
